import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './autoRechargeInit.json';

const autoRechargeInit = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['autoRechargeController/autoRechargeInit'].success.default)));
};

const checkMsisdn = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['autoRechargeController/checkMsisdn'].success.default)));
};

const validateAndSendOTP = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['safetyAuthorizeController/validateAndSendOTP'].success.default)));
};

const checkOTP = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['safetyAuthorizeController/checkOTP'].success.default)));
};

const applyAutoRecharge = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['autoRechargeController/applyAutoRecharge'].success.default)));
};

const cancelAutoRecharge = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['autoRechargeController/cancelAutoRecharge'].success.default)));
};

const extendCreditCard = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['autoRechargeController/extendCreditCard'].success.default)));
};

const validateCreditCard = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['autoRechargeController/validateCreditCard'].success.default)));
};
const getPayPageInit = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['autoRechargeController/getPayPageInit'].success.default)));
};

export const handlers = [
  rest.post(getApiEndpoint('autoRechargeController/autoRechargeInit'), withScenario(withAuthCheck(autoRechargeInit))),
  rest.post(getApiEndpoint('autoRechargeController/checkMsisdn'), withScenario(withAuthCheck(checkMsisdn))),
  rest.post(
    getApiEndpoint('safetyAuthorizeController/validateAndSendOTP'),
    withScenario(withAuthCheck(validateAndSendOTP))
  ),
  rest.post(getApiEndpoint('safetyAuthorizeController/checkOTP'), withScenario(withAuthCheck(checkOTP))),
  rest.post(getApiEndpoint('autoRechargeController/applyAutoRecharge'), withScenario(withAuthCheck(applyAutoRecharge))),
  rest.post(
    getApiEndpoint('autoRechargeController/cancelAutoRecharge'),
    withScenario(withAuthCheck(cancelAutoRecharge))
  ),
  rest.post(getApiEndpoint('autoRechargeController/extendCreditCard'), withScenario(withAuthCheck(extendCreditCard))),
  rest.post(
    getApiEndpoint('autoRechargeController/validateCreditCard'),
    withScenario(withAuthCheck(validateCreditCard))
  ),
  rest.post(getApiEndpoint('autoRechargeController/getPayPageInit'), withScenario(withAuthCheck(getPayPageInit))),
];
